import React, { useCallback, useMemo, useRef } from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';

import { Badge, Button, Text } from '../../../../../../common';

import shoppingCart from '../../../../../../assets/icons/shopping-cart.svg';

const Size = props => {
  const { size, available, onClick } = props;
  const badgeRef = useRef();
  const { t } = useTranslation();

  const amount = useMemo(
    () => available.length,
    [available]
  );

  const handleOnClick = useCallback(
    option => () => {
      onClick(option, badgeRef.current)
    },
    [onClick]
  );

  return (
    <div
      onClick={
        amount
          ? handleOnClick(available[0])
          : () => {}
      }
      className={clsx(
        'size-item'
      )}
    >
      <Button
        disabled={!amount}
        transparent={!amount}
        style={{ height: 'auto', display: 'flex', alignItems: 'center' }}
      >
        <img
          src={shoppingCart}
          alt="shopping cart"
          width="15"
          height="15"
          style={{ marginRight: 10 }}
        />
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          <Text p ghost>{size}</Text>
          <Text p bold>{t`Add to cart`}</Text>
        </div>
      </Button>
      <Badge ref={badgeRef} text={amount} />
    </div>
  );
};

Size.propTypes = {
  size: PropTypes.string.isRequired,
  available: PropTypes.array,
  onClick: PropTypes.func.isRequired
};

export default Size;